import React, { useState, useEffect, useCallback } from 'react';
// import store from '@/store';
import { Modal, Form, Input, Range, Icon } from '@b-design/fusion';
import ApplyReleasing from '@/components/ApplyReleasing';
import Button, { promisifyValidate } from '@/components/Button';
import { history } from 'ice';
import { Timeline } from 'antd';
import $i18n from '@/i18n';
import QRCode from '@/components/QRCode';
import Requests from '@/services/request';
import { formatTime } from '@/utils';
import { Field } from '@alifd/next';
import { getQueryStringArgs } from '@/utils/url-parse';

import './index.less';

interface VersionDescription {
  name: string;
  appId: string;
  iconPublicUrl: string;
  slogan: string;
  description: string;
  customerEmail: string;
  customerPhone: string;
  inherit: boolean;
}
interface App {
  framework: string;
}
interface VersionDetail {
  createName: string;
  modifiedName: string;
  gmtCreate: string;
  gmtModified: string;
  comment: string;
  channelName: string;
  changelog: string;
  version: string;
  appId: string;
  channelCode: string;
  versionStatus: string;
  versionDescription: VersionDescription;
  app: App;
}
interface HistoryList {
  createName: string;
  type: string;
  gmtCreate: string;
  extInfo?: any;
}
interface Props {
  spaceId: string | (string | null)[] | null;
  historyList: HistoryList[];
  versionDetail: VersionDetail;
  initDataSource: () => void;
}

const Record: React.FC<Props> = ({ historyList, versionDetail, initDataSource, spaceId }) => {
  const field = Field.useField();
  const { init, getError, setValue } = field;
  const [visible, setVisible] = useState(false);
  const [whiteListVisible, setWhiteListVisible] = useState(false);
  const [inputValue, setInputValue] = useState('1');
  const [rangeValue, setRangeValue] = useState(parseInt(inputValue));
  const [rangeVisible, setRangeVisible] = useState(false);
  const [onlineData, setOnlineData] = useState<any>({});
  const [approveId, setApproveId] = useState<string>('');
  const [authority, setAuthority] = useState<any>({});
  const [QRCodeUrl, setQRCodeUrl] = useState('');
  const { gmtCreate, versionStatus, createName, version, channelName, modifiedName, gmtModified } = versionDetail;

  const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 10 },
  };

  const { appId, channelCode } = getQueryStringArgs();

  useEffect(() => {
    const approveList = historyList.filter((i) => i?.type === 'START_APPROVE')[0];
    const url = historyList.filter((i) => i.type === 'CREATE')[0]?.extInfo?.previewUrl || '';
    setQRCodeUrl(url);
    setApproveId(approveList?.extInfo?.approveId);
  }, [historyList]);

  useEffect(() => {
    const garyList = historyList.filter((i) => i?.type === 'GRAY_PUBLISH')[0];
    setInputValue(garyList?.extInfo?.percentage || 1);
    setRangeValue(parseInt(garyList?.extInfo?.percentage) || 1);
  }, [rangeVisible]);

  // 获取上线数据
  const getOnlineData = async () => {
    const res = await Requests.get('/rest/intercnn/app/publish/query', {
      appId,
      channelCode,
    });
    if (res) {
      setOnlineData(res.list[0]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getOnlineData();
      if (!spaceId) {
        return;
      }
      const res = await Requests.get('/rest/intercnn/app/query', {
        appIdList: appId,
        spaceId,
      });
      if (res) {
        setAuthority(res?.list[0]);
      }
    };
    fetchData();
  }, [appId]);

  const jumpStatus = () => {
    history?.push(
      `/miniapp/statusDetail?version=${version}&appId=${appId}&channelCode=${channelCode}&approveId=${approveId}&spaceId=${spaceId || ''}`,
    );
  };
  const setWhiteList = async () => {
    if (versionStatus == 'BETA_TEST') {
      const res = await Requests.get('/rest/intercnn/app/publish/version/polite/query', {
        appId,
        channelCode,
        version,
      });
      if (res) {
        setValue('whitelist', res.idList.join('\n'));
      } else {
        const fallbackRes = await Requests.get('/rest/intercnn/app/publish/version/polite/query', {
          appId,
        });
        if (fallbackRes) {
          setValue('whitelist', fallbackRes.idList.join('\n'));
        }
      }
    } else {
      const res = await Requests.get('/rest/intercnn/app/publish/version/polite/query', {
        appId,
      });
      if (res) {
        setValue('whitelist', res.idList.join('\n'));
      }
    }
    setWhiteListVisible(true);
  };

  // 跳过白名单
  const skipWhiteList = async () => {
    const data = await Requests.post('/rest/intercnn/app/publish/version/gray/skipBeta', {
      appId,
      channelCode,
      version,
    });
    if (data) {
      initDataSource();
    }
  };

  // 正式发布
  const submitRelease = async () => {
   const data = await Requests.post('/rest/intercnn/app/publish/online', {
      appId,
      channelCode,
      version,
    })
    if (data) {
      initDataSource();
    }
  };

  const officiallyRelease = () => {
    Modal.confirm({
      title: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.gray.Officially.Release',
        dm: '正式发布',
      }),
      content: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.gray.Whether.Officially.Release',
        dm: '是否正式发布？',
      }),
      footerActions: ['cancel', 'ok'],
      onOk: submitRelease,
      style: { width: '340px' },
    });
  };

  const skipWhite = () => {
    Modal.confirm({
      title: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.whiteList.Skip',
        dm: '跳过',
      }),
      content: $i18n.get({
        id: 'aopf.pages.release.skip.whiteList',
        dm: '是否跳过白名单设置？',
      }),
      footerActions: ['cancel', 'ok'],
      onOk: skipWhiteList,
      style: { width: '340px' },
    });
  };

  const goRollBack = async (versions: string) => {
    const data = await Requests.post('/rest/intercnn/app/publish/online', {
      appId,
      channelCode,
      version: versions,
    });
    if (data) {
      initDataSource();
      await getOnlineData();
    }
  };

  // 版本回退
  const rollBackVersion = (v: string) => {
    Modal.confirm({
      title: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.gray.Rollback',
        dm: '回滚',
      }),
      content: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.gray.Rollback.Or.Not',
        dm: '是否回滚？',
      }),
      footerActions: ['cancel', 'ok'],
      onOk: () => goRollBack(v),
      style: { width: '340px' },
    });
  };

  const renderCurProgress = useCallback(() => {
    let text;
    if (authority?.role !== 'ADMIN') return (text = '');
    switch (versionStatus) {
      case 'CREATED':
        text = (
          <Timeline.Item dot={<div className="timeline-dot"></div>}>
            <div className="record-content">
              <div className="record-weight-dec">
                <span>
                  {$i18n.get(
                    {
                      id: 'aopf.pages.miniapp.version.tabs.release.built',
                      dm: '{name}的迷你应用程序包已构建',
                    },
                    { name: versionDetail?.versionDescription?.name },
                  )}
                </span>
              </div>
              <QRCode url={QRCodeUrl} />
            </div>
            <div className="record-time">
              <span>{formatTime(gmtCreate)}</span>
            </div>
            {authority?.role === 'ADMIN' && (
              <Button className="record-btn" type="primary" onClick={() => setVisible(true)}>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.tabs.release.Apply.Release',
                  dm: '应用版本',
                })}
              </Button>
            )}
          </Timeline.Item>
        );
        break;
      case 'APPROVE':
        text = (
          <Timeline.Item dot={<div className="timeline-dot"></div>}>
            <div className="record-content">
              <div className="record-weight-dec">
                <span className="record-name">{modifiedName}</span>
                <span>
                  {$i18n.get(
                    {
                      id: 'aopf.pages.miniapp.version.info.submit.Submitted',
                      dm: '已提交发布申请，正在等待{channelName}管理员的批准',
                    },
                    { channelName: channelName },
                  )}
                </span>
                {authority?.role === 'ADMIN' && approveId && (
                  <span className="record-option" onClick={jumpStatus}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.submit.View.Status',
                      dm: '查看状态',
                    })}
                  </span>
                )}
              </div>
            </div>
            <div className="record-time">
              <span>{formatTime(gmtModified)}</span>
            </div>
          </Timeline.Item>
        );
        break;
      case 'PASSED':
        if (onlineData?.publishStatus !== 'ONLINE') {
          text = (
            <Timeline.Item dot={<div className="timeline-dot"></div>}>
              <div className="record-content">
                <div className="record-weight-dec">
                  <span className="record-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.officially',
                      dm: '目前，还没有正式在线发布的版本，因此无法进行试点测试和灰度级发布。请先进行正式发布。',
                    })}
                  </span>
                </div>
              </div>
              <div className="record-time">{formatTime(gmtModified)}</div>
              {authority?.role === 'ADMIN' && (
                <>
                  <Button className="record-white-btn" type="primary" onClick={officiallyRelease}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.gray.Officially.Release',
                      dm: '正式发布',
                    })}
                  </Button>
                </>
              )}
            </Timeline.Item>
          );
        } else {
          text = (
            <Timeline.Item dot={<div className="timeline-dot"></div>}>
              <div className="record-content">
                <div className="record-weight-dec">
                  <span className="record-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.submit.Prepare.Whitelist',
                      dm: '准备白名单测试',
                    })}
                  </span>
                </div>
              </div>
              <div className="record-time">
                <span>{formatTime(gmtCreate)}</span>
              </div>
              <Button
                className="record-white-btn"
                style={{ marginRight: '8px' }}
                type="primary"
                onClick={setWhiteList}
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.whiteList.Setting.Whitelist',
                  dm: '设置白名单',
                })}
              </Button>
              <Button className="record-white-btn-right" onClick={skipWhite}>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.whiteList.Skip',
                  dm: '跳过',
                })}
              </Button>
            </Timeline.Item>
          );
        }
        break;
      case 'BETA_TEST':
      case 'BETA_TEST_SUSPEND':
        if (onlineData?.publishStatus !== 'ONLINE') {
          text = (
            <Timeline.Item dot={<div className="timeline-dot"></div>}>
              <div className="record-content">
                <div className="record-weight-dec">
                  <span className="record-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.officially',
                      dm: '目前，还没有正式在线发布的版本，因此无法进行试点测试和灰度级发布。请先进行正式发布。',
                    })}
                  </span>
                </div>
              </div>
              <div className="record-time">{formatTime(gmtModified)}</div>
              {authority?.role === 'ADMIN' && (
                <>
                  <Button className="record-white-btn" type="primary" onClick={officiallyRelease}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.gray.Officially.Release',
                      dm: '正式发布',
                    })}
                  </Button>
                </>
              )}
            </Timeline.Item>
          );
        } else {
          text = (
            <Timeline.Item dot={<div className="timeline-dot"></div>}>
              <div className="record-content">
                <div className="record-weight-dec">
                  <span className="record-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.whiteList.Whitelisting',
                      dm: '正在进行白名单测试',
                    })}
                  </span>
                </div>
              </div>
              <div className="record-time">
                <span>{formatTime(gmtCreate)}</span>
              </div>
              <Button className="record-white-btn" type="primary" onClick={setWhiteList}>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.whiteList.Setting.Whitelist',
                  dm: '设置白名单',
                })}
              </Button>
              <Button
                className="record-white-btn-right"
                onClick={() => {
                  setRangeVisible(true);
                  setInputValue('1');
                  setRangeValue(1);
                }}
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.whiteList.Start.Grayscale',
                  dm: '开始灰度',
                })}
              </Button>
            </Timeline.Item>
          );
        }
        break;
      // case 'PASSED':
      // case 'BETA_TEST':
      // case 'BETA_TEST_SUSPEND':
      case 'GRAY_SUSPEND':
      case 'GRAY':
        if (onlineData?.publishStatus !== 'ONLINE') {
          text = (
            <Timeline.Item dot={<div className="timeline-dot"></div>}>
              <div className="record-content">
                <div className="record-weight-dec">
                  <span className="record-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.officially',
                      dm: '目前，还没有正式在线发布的版本，因此无法进行试点测试和灰度级发布。请先进行正式发布。',
                    })}
                  </span>
                </div>
              </div>
              <div className="record-time">{formatTime(gmtModified)}</div>
              {authority?.role === 'ADMIN' && (
                <>
                  <Button className="record-white-btn" type="primary" onClick={officiallyRelease}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.gray.Officially.Release',
                      dm: '正式发布',
                    })}
                  </Button>
                </>
              )}
            </Timeline.Item>
          );
        } else {
          text = (
            <Timeline.Item dot={<div className="timeline-dot"></div>}>
              <div className="record-content">
                <div className="record-weight-dec">
                  <span className="record-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.gray.Gray.Publishing',
                      dm: '灰度发布可用，准备灰度发布',
                    })}
                  </span>
                </div>
              </div>
              <div className="record-time">{formatTime(gmtCreate)}</div>
              {authority?.role === 'ADMIN' && (
                <>
                  <Button className="record-white-btn" type="primary" onClick={officiallyRelease}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.gray.Officially.Release',
                      dm: '正式发布',
                    })}
                  </Button>
                  <Button
                    className="record-white-btn-right"
                    onClick={() => {
                      setRangeVisible(true);
                      setInputValue('1');
                      setRangeValue(1);
                    }}
                  >
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.whiteList.Set.Grayscale',
                      dm: '设置灰度',
                    })}
                  </Button>
                </>
              )}
            </Timeline.Item>
          );
        }
        break;
      default:
        break;
    }
    return text;
  }, [authority, versionStatus, onlineData, approveId, QRCodeUrl]);

  const renderContent = (v) => {
    const { type, createName: name, gmtCreate: time, modifiedName: modName, extInfo } = v;
    let text;
    switch (type) {
      case 'CREATE':
        if (versionStatus === 'CREATED') {
          text = (
            <Timeline.Item color="gray">
              <div className="record-content">
                <span className="record-name">{createName}</span>
                <span className="record-dec">
                  {$i18n.get(
                    {
                      id: 'aopf.pages.miniapp.version.tabs.release.create.version',
                      dm: '为发布创建新版本',
                    },
                    { version: version },
                  )}
                </span>
              </div>
              <div className="record-time">{formatTime(gmtCreate)}</div>
            </Timeline.Item>
          );
        } else {
          text = (
            <>
              <Timeline.Item color="gray">
                <div className="record-content">
                  <span>
                    {$i18n.get(
                      {
                        id: 'aopf.pages.miniapp.version.tabs.release.built',
                        dm: '{name}的迷你应用程序包已构建',
                      },
                      { name: versionDetail?.versionDescription?.name },
                    )}
                  </span>
                  <QRCode url={extInfo?.previewUrl} />
                </div>
                <div className="record-time">{formatTime(time)}</div>
              </Timeline.Item>
              <Timeline.Item color="gray">
                <div className="record-content">
                  <span className="record-name">{createName}</span>
                  <span className="record-dec">
                    {$i18n.get(
                      {
                        id: 'aopf.pages.miniapp.version.tabs.release.create.version',
                        dm: '为发布创建新版本',
                      },
                      { version: version },
                    )}
                  </span>
                </div>
                <div className="record-time">{formatTime(gmtCreate)}</div>
              </Timeline.Item>
            </>
          );
        }
        break;
      case 'START_APPROVE':
        if (versionStatus !== 'APPROVE') {
          text = (
            <Timeline.Item color="gray">
              <div className="record-content">
                <span className="record-name">{name}</span>
                <span className="record-dec">
                  {$i18n.get(
                    {
                      id: 'aopf.pages.miniapp.version.info.submit.Submitted',
                      dm: '已提交发布申请，正在等待{channelName}管理员的批准',
                    },
                    { channelName: channelName },
                  )}
                </span>
              </div>
              <div className="record-time">{formatTime(time)}</div>
            </Timeline.Item>
          );
        }
        break;
      case 'APPROVE_RESULT':
        if (extInfo?.result == 'PASSED') {
          text = (
            <Timeline.Item color="gray">
              <div className="record-content">
                <span className="record-name">{name}</span>
                <span className="record-dec">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.submit.Agree.Release',
                    dm: '已同意发布应用程序',
                  })}
                </span>
                {authority?.role === 'ADMIN' && (
                  <span className="record-option" onClick={jumpStatus}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.submit.View.Detail',
                      dm: '查看详情',
                    })}
                  </span>
                )}
              </div>
              <div className="record-time">{formatTime(time)}</div>
            </Timeline.Item>
          );
        } else if (extInfo?.result == 'REJECT') {
          text = (
            <Timeline.Item color="gray">
              <div className="record-content">
                <span className="record-name">{modName}</span>
                <span className="record-dec">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.submit.Refused.Version',
                    dm: '已拒绝版本发布应用程序',
                  })}
                </span>
                {versionStatus === 'REJECT' && authority?.role === 'ADMIN' && (
                  <span className="record-option" onClick={() => setVisible(true)}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.tabs.release.Apply.To.Release',
                      dm: '去发布',
                    })}
                  </span>
                )}
              </div>
              <div className="record-time">{formatTime(time)}</div>
            </Timeline.Item>
          );
        } else {
          text = (
            <Timeline.Item color="gray">
              <div className="record-content">
                <span className="record-name">{modName}</span>
                <span className="record-dec">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.submit.Withdrew.Version',
                    dm: '已撤回版本发布应用程序',
                  })}
                </span>
                {versionStatus === 'WITHDRAW' && authority?.role === 'ADMIN' && (
                  <span className="record-option" onClick={() => setVisible(true)}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.tabs.release.Apply.To.Release',
                      dm: '去发布',
                    })}
                  </span>
                )}
              </div>
              <div className="record-time">{formatTime(time)}</div>
            </Timeline.Item>
          );
        }
        break;
      case 'SKIP_BETA_TEST':
        text = (
          <Timeline.Item color="gray">
            <div className="record-content">
              <span className="record-name">{name}</span>
              <span className="record-dec">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.whiteList.Ended.Testing',
                  dm: '白名单测试结束',
                })}
              </span>
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'BETA_TEST':
        text = (
          <Timeline.Item color="gray">
            <div className="record-content">
              <span className="record-dec">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.submit.Prepare.Whitelist',
                  dm: '准备白名单测试',
                })}
              </span>
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'SUSPEND_BETA_TEST':
        text = (
          <Timeline.Item color="gray">
            <div className="record-content">
              <span className="record-name">{name}</span>
              <span className="record-dec">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.submit.End.Pilot',
                  dm: '结束试点测试',
                })}
              </span>
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'GRAY_PUBLISH':
        text = (
          <Timeline.Item color="gray">
            <div className="record-content">
              <span className="record-dec">
                {$i18n.get(
                  {
                    id: 'aopf.pages.miniapp.version.info.gray.Current.Gray',
                    dm: '当前灰度为{percentage}%',
                  },
                  { percentage: extInfo?.percentage },
                )}
              </span>
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'SUSPEND_GRAY_PUBLISH':
        text = (
          <Timeline.Item color="gray">
            <div className="record-content">
              <span className="record-name">{name}</span>
              <span className="record-dec">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.submit.End.Gray',
                  dm: '结束灰度测试',
                })}
              </span>
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'RELEASE':
        text = (
          <Timeline.Item
            dot={
              versionStatus === 'ONLINE' && historyList[0].gmtCreate === time ? (
                <div className="timeline-dot"></div>
              ) : (
                <div className="timeline-dot-no"></div>
              )
            }
          >
            <div className="record-content">
              <span className="record-name">{name}</span>
              <span
                className={
                  versionStatus === 'ONLINE' && historyList[0].gmtCreate === time
                    ? 'record-weight-dec'
                    : 'record-dec'
                }
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.gray.Has.Officially.Released',
                  dm: '正式发布',
                }) + versionDetail?.versionDescription?.name}
                &nbsp;v<span>{extInfo?.version}</span>
              </span>
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'ARCHIVED':
        text = (
          <Timeline.Item
            dot={
              versionStatus === 'OFFLINE' && historyList[0].gmtCreate === time ? (
                <div className="timeline-dot"></div>
              ) : (
                <div className="timeline-dot-no"></div>
              )
            }
          >
            <div className="record-content">
              <span
                className={
                  versionStatus === 'OFFLINE' && historyList[0].gmtCreate === time
                    ? 'record-weight-dec'
                    : 'record-dec'
                }
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.process.Filed.Version',
                  dm: '此版本已存档，因为频道上提供了新版本',
                })}
              </span>
              {authority?.role === 'ADMIN' &&
                historyList.filter((i) => i.type === 'ARCHIVED')[0].gmtCreate === time &&
                onlineData?.onlineVersion !== version && (
                  <>
                    <span className="record-icon">
                      <Icon type="logout" size="xs" />
                    </span>
                    <span
                      className="record-option"
                      onClick={() => rollBackVersion(versionDetail?.version)}
                    >
                      {$i18n.get({
                        id: 'aopf.pages.miniapp.version.info.process.RollBack',
                        dm: '回退',
                      })}
                    </span>
                  </>
                )}
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      case 'OFFLINE':
        text = (
          <Timeline.Item
            dot={
              versionStatus === 'OFFLINE' && historyList[0].gmtCreate === time ? (
                <div className="timeline-dot"></div>
              ) : (
                <div className="timeline-dot-no"></div>
              )
            }
          >
            <div className="record-content">
              <span
                className={
                  versionStatus === 'OFFLINE' && historyList[0].gmtCreate === time
                    ? 'record-weight-dec'
                    : 'record-dec'
                }
              >
                {extInfo?.reason === 'OFFLINE' ? (
                  <div>
                    <span>
                      {$i18n.get(
                        {
                          id: 'aopf.pages.release.blocked.version',
                          dm: '由于某种原因，{channelName}管理员暂时阻止了当前版本。',
                        },
                        { channelName: channelName },
                      )}
                    </span>
                  </div>
                ) : (
                  $i18n.get({
                    id: 'aopf.pages.miniapp.version.info.process.Filed.Version',
                    dm: '此版本已存档，因为频道上提供了新版本',
                  })
                )}
              </span>
              {authority?.role === 'ADMIN' &&
                historyList.filter((i) => i.type === 'OFFLINE')[0].gmtCreate === time &&
                onlineData?.onlineVersion !== version && (
                  <>
                    <span className="record-icon">
                      <Icon type="logout" size="xs" />
                    </span>
                    <span
                      className="record-option"
                      onClick={() => rollBackVersion(versionDetail?.version)}
                    >
                      {$i18n.get({
                        id: 'aopf.pages.miniapp.version.info.process.RollBack',
                        dm: '回退',
                      })}
                    </span>
                  </>
                )}
            </div>
            <div className="record-time">{formatTime(time)}</div>
          </Timeline.Item>
        );
        break;
      default:
        break;
    }
    return text;
  };

  // 白名单测试
  const submitWhiteList = async () => {
    const [errs, val] = await promisifyValidate(field);
    if (errs) return;
    const list = val?.whitelist.split(/[(\r\n)\r\n]+/);
    await Requests.post('/rest/intercnn/app/publish/version/polite/create', {
      appId,
      idList: list,
      channelCode,
      version,
    });
    const result = await Requests.post('/rest/intercnn/app/publish/version/gray/beta', {
      appId,
      channelCode,
      version,
      idList: list,
    });
    if (result) {
      setWhiteListVisible(false);
      initDataSource();
    }
  };

  // 灰度测试
  const submitGray = async () => {
    const data = await Requests.post('/rest/intercnn/app/publish/version/gray/gray', {
      appId,
      channelCode,
      version,
      percentage: Number(inputValue),
    });
    if (data) {
      setRangeVisible(false);
      initDataSource();
    }
  };

  return (
    <div className="record-container">
      <Timeline>
        {renderCurProgress()}
        {historyList?.map((i) => renderContent(i))}
      </Timeline>
      <ApplyReleasing
        visible={visible}
        spaceId={spaceId || ''}
        setVisible={setVisible}
        versionDetail={versionDetail}
        initDataSource={initDataSource}
      />
      <Modal
        title={$i18n.get({
          id: 'aopf.pages.miniapp.version.info.whiteList.Setting.Whitelist',
          dm: '设置白名单',
        })}
        style={{ width: '634px' }}
        visible={whiteListVisible}
        onOk={submitWhiteList}
        onCancel={() => setWhiteListVisible(false)}
        onClose={() => setWhiteListVisible(false)}
        footer={[
          <Button key="cancel" className="btn-left" onClick={() => setWhiteListVisible(false)}>
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.confirm.Cancel',
              dm: '取消',
            })}
          </Button>,
          <Button key="submit" type="primary" onClick={submitWhiteList}>
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.whiteList.Start.Testing',
              dm: '开始测试',
            })}
          </Button>,
        ]}
      >
        <Form
          className="form-container"
          labelAlign={'left'}
          labelTextAlign={'right'}
          {...formItemLayout}
        >
          <Form.Item
            name="whitelist"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.version.info.whiteList.Whitelist',
              dm: '白名单',
            })}
            required
          >
            <Input.TextArea
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.Version.tabs.Release.user.uid',
                dm: '请输入用户uid，每行一个',
              })}
              autoHeight={{ minRows: 6, maxRows: 10 }}
              style={{ width: '465px', height: '223px' }}
              {...init('whitelist', {
                initValue: '',
                rules: [
                  {
                    required: true,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.Version.tabs.Release.user.uid',
                      dm: '请输入用户uid，每行一个',
                    }),
                  },
                  {
                    validator: (rule, value: string) => {
                      const list = value?.split(/[(\r\n)\r\n]+/);
                      if (list.length > 50) {
                        return Promise.reject(
                          new Error(
                            $i18n.get({
                              id: 'aopf.pages.miniapp.Version.tabs.Release.lines',
                              dm: '最多50行',
                            }),
                          ),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    validator: (rule, value: string) => {
                      const list = value?.split(/[(\r\n)\r\n]+/);
                      const maxUidLength = list.filter((i) => i?.length > 32);
                      if (maxUidLength?.length > 0) {
                        return Promise.reject(
                          new Error(
                            $i18n.get({
                              id: 'aopf.pages.miniapp.Version.tabs.UID.lines',
                              dm: 'UID的最大长度为32个字符',
                            }),
                          ),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ],
              })}
            />
            <p className="errMsg">{getError('whitelist')}</p>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title={$i18n.get({
          id: 'aopf.pages.miniapp.version.info.whiteList.Set.Grayscale',
          dm: '设置灰度',
        })}
        data-size="small"
        visible={rangeVisible}
        onOk={submitGray}
        onCancel={() => setRangeVisible(false)}
        onClose={() => setRangeVisible(false)}
        footer={[
          <Button key="cancel" className="btn-left" onClick={() => setRangeVisible(false)}>
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.confirm.Cancel',
              dm: '取消',
            })}
          </Button>,
          <Button key="submit" type="primary" onClick={submitGray}>
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.whiteList.Start.Grayscale',
              dm: '开始灰度',
            })}
          </Button>,
        ]}
      >
        <Form className="form-container">
          <Form.Item
            name="grayscale"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.version.info.whiteList.Set.Grayscale',
              dm: '设置灰度',
            })}
            required
          >
            <div className="range-form">
              <Range
                value={rangeValue}
                min={0}
                max={99}
                onProcess={(v) => {
                  setRangeValue(v);
                  setInputValue(`${v}`);
                }}
                className="range-value"
              />
              <Input
                value={inputValue}
                onChange={(v) => {
                  setInputValue(v);
                  const tmp = parseInt(v);
                  if (tmp > 99) {
                    setInputValue('99');
                    setRangeValue(99);
                  }
                  if (tmp === 0 || (tmp > 0 && tmp <= 99)) {
                    setRangeValue(tmp);
                  }
                }}
                className="range-input"
              />
              <span>%</span>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default Record;
